<template>
  <div>
    <v-container fluid>
      <base-material-card
        icon="mdi-view-dashboard"
        title="ข้อมูลสถานศึกษา — ภาพรวม"
        class="px-5 py-3"
      >
        <!-- สรุปสถิติ -->
        <v-row dense class="mb-2">
          <v-col cols="6" md="3">
            <v-card outlined class="pa-3 rounded-lg text-center stat-card">
              <div class="stat-value" style="color:#1565c0">{{ dashboardData.overall.total_colleges || 0 }}</div>
              <div class="stat-label">สถานศึกษาทั้งหมด</div>
            </v-card>
          </v-col>
          <v-col cols="6" md="3">
            <v-card outlined class="pa-3 rounded-lg text-center stat-card">
              <div class="stat-value" style="color:#2e7d32">{{ dashboardData.overall.total_provinces || 0 }}</div>
              <div class="stat-label">จังหวัดที่มีสถานศึกษา</div>
            </v-card>
          </v-col>
          <v-col cols="6" md="3">
            <v-card outlined class="pa-3 rounded-lg text-center stat-card">
              <div class="stat-value" style="color:#e65100">{{ dashboardData.overall.total_regions || 0 }}</div>
              <div class="stat-label">ภาค</div>
            </v-card>
          </v-col>
          <v-col cols="6" md="3">
            <v-card outlined class="pa-3 rounded-lg text-center stat-card">
              <div class="stat-value" style="color:#6a1b9a">{{ dashboardData.overall.total_types || 0 }}</div>
              <div class="stat-label">ประเภทสถานศึกษา</div>
            </v-card>
          </v-col>
        </v-row>

        <!-- กราฟแบ่งประเภท + ภาค -->
        <v-row dense class="mb-2" v-if="dashboardLoaded">
          <v-col cols="12" md="5">
            <v-card outlined class="pa-3 rounded-lg">
              <div class="chart-title">แบ่งตามประเภทสถานศึกษา</div>
              <apexchart type="donut" height="260" :options="typeChartOptions" :series="typeChartSeries"></apexchart>
            </v-card>
          </v-col>
          <v-col cols="12" md="7">
            <v-card outlined class="pa-3 rounded-lg">
              <div class="chart-title">แบ่งตามภาค</div>
              <apexchart type="bar" height="260" :options="regionChartOptions" :series="regionChartSeries"></apexchart>
            </v-card>
          </v-col>
        </v-row>

        <!-- แผนที่ -->
        <v-row dense class="mb-4" v-if="dashboardLoaded">
          <v-col cols="12">
            <college-map-dashboard :by-province="dashboardData.by_province" @filter-province="onMapFilterProvince" />
          </v-col>
        </v-row>

        <v-divider class="mb-4"></v-divider>

        <!-- ตัวกรอง + ตารางรายชื่อ -->
        <v-row dense class="mb-2">
          <v-col cols="12" sm="4" md="3">
            <v-select
              v-model="filterRegion"
              :items="regionOptions"
              label="กรองตามภาค"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-select
              v-model="filterProvince"
              :items="provinceOptions"
              label="กรองตามจังหวัด"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-select
              v-model="filterType"
              :items="typeOptions"
              label="กรองตามประเภท"
              clearable
              outlined
              dense
              hide-details
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
              single-line
              hide-details
              dense
              outlined
            />
          </v-col>
        </v-row>

        <v-data-table
          color="success"
          :loading="loading"
          :headers="headers"
          :items="filteredColleges"
          :search="search"
        >
          <template v-slot:item.view="{ item }">
            <v-btn
              fab
              small
              color="blue"
              :to="`/pages/collegesid/?college_ID=${item.college_code}`"
            >
              <v-icon>
                mdi-magnify
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:item.collegeDev="{ item }">
            <div v-if="item.collegeDev === 'Dev' || item.collegeDev === 'dev'" class="text-center">
              <v-icon color="green">mdi-checkbox-marked-circle-outline</v-icon>
              พัฒนา
            </div>
          </template>

          <template v-slot:item.college_vecpro="{ item }">
            <div v-if="item.college_vecpro === '1' || item.college_vecpro === 1" class="text-center">
              <v-icon color="green">mdi-checkbox-marked-circle-outline</v-icon>
              สอจ.
            </div>
          </template>


          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
            >ไม่พบผลลัพธ์ "{{ search }}" ที่คุณกำลังค้นหา.</v-alert
          >
        </v-data-table>
      </base-material-card>
    </v-container>

    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>
          {{ snackbar.text }}
        </v-card-text>

        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import CollegeMapDashboard from "../components/core/CollegeMapDashboard.vue";

export default {
  components: { CollegeMapDashboard },
  data() {
    return {
      loading: true,
      dashboardLoaded: false,
      ApiKey: "HRvec2021",
      valid: true,
      snackbar: {
        show: false,
        color: "",
        timeout: 5000,
        icon: "",
        text: ""
      },
      colleges: [],
      dashboardData: {
        overall: {},
        by_type: [],
        by_region: [],
        by_province: []
      },

      search: "",
      filterRegion: null,
      filterProvince: null,
      filterType: null,

      headers: [
        { text: "View", align: "left", value: "view" },
        { text: "ชื่อสถานศึกษา", align: "left", value: "college_name" },
        { text: "ชื่อย่อ", align: "left", value: "collegeIni" },
        { text: "สถาบันการอาชีวศึกษา", align: "left", value: "veiVocalName" },
        { text: "อำเภอ", align: "left", value: "prefecture_name" },
        { text: "จังหวัด", align: "left", value: "province_name" },
        { text: "ภาค", align: "left", value: "region_name" },
        { text: "ประเภท", align: "left", value: "collegetype_name" },
        { text: "สถานศึกษาพัฒนา", align: "left", value: "collegeDev" },
        { text: "สอจ.", align: "left", value: "college_vecpro" }
      ]
    };
  },
  async mounted() {
    await Promise.all([this.collegeQueryAll(), this.dashboardStatsQuery()]);
  },

  methods: {
    async collegeQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("college_directory.php", {
          ApiKey: this.ApiKey
        })
        .finally(() => (this.loading = false));
      this.colleges = Array.isArray(result.data) ? result.data : [];
    },

    async dashboardStatsQuery() {
      let result = await this.$http.post("college_dashboard_stats.php", {
        ApiKey: this.ApiKey
      });
      if (result.data && result.data.status) {
        this.dashboardData = result.data;
        this.dashboardLoaded = true;
      }
    },

    onMapFilterProvince(prov) {
      this.filterProvince = prov.province;
      this.filterRegion = null;
    }
  },
  computed: {
    regionOptions() {
      return [...new Set(this.colleges.map(c => c.region_name).filter(Boolean))].sort();
    },
    provinceOptions() {
      return [...new Set(this.colleges.map(c => c.province_name).filter(Boolean))].sort();
    },
    typeOptions() {
      return [...new Set(this.colleges.map(c => c.collegetype_name).filter(Boolean))].sort();
    },
    filteredColleges() {
      return this.colleges.filter(c => {
        if (this.filterRegion && c.region_name !== this.filterRegion) return false;
        if (this.filterProvince && c.province_name !== this.filterProvince) return false;
        if (this.filterType && c.collegetype_name !== this.filterType) return false;
        return true;
      });
    },

    typeChartSeries() {
      return this.dashboardData.by_type.map(t => t.total);
    },
    typeChartOptions() {
      return {
        labels: this.dashboardData.by_type.map(t => t.collegetype_name || "ไม่ระบุ"),
        legend: { position: "bottom", fontFamily: "Kanit" },
        dataLabels: { enabled: true },
        colors: ["#1565c0", "#2e7d32", "#e65100", "#6a1b9a", "#00838f", "#c2185b", "#5d4037"]
      };
    },

    regionChartSeries() {
      return [{ name: "จำนวนสถานศึกษา", data: this.dashboardData.by_region.map(r => r.total) }];
    },
    regionChartOptions() {
      return {
        chart: { toolbar: { show: false } },
        xaxis: { categories: this.dashboardData.by_region.map(r => r.region_name || "ไม่ระบุ") },
        dataLabels: { enabled: true },
        colors: ["#1565c0"],
        plotOptions: { bar: { borderRadius: 4, horizontal: false } }
      };
    }
  }
};
</script>

<style scoped>
.stat-card {
  transition: all 0.2s ease;
}
.stat-value {
  font-size: 1.8rem;
  font-weight: 800;
}
.stat-label {
  font-size: 0.8rem;
  color: #6b7280;
}
.chart-title {
  font-size: 0.85rem;
  font-weight: 700;
  color: #374151;
  margin-bottom: 8px;
}
</style>
